{
  "MFA_SETTINGS": {
    "TITLE": "Two-Factor Authentication",
    "SUBTITLE": "Protect your account from unauthorized access with TOTP-based authentication. This adds an extra layer of security to your account.",
    "DESCRIPTION": "Add an extra layer of security to your account using a time-based one-time password (TOTP)",
    "STATUS_TITLE": "Authentication Status",
    "STATUS_DESCRIPTION": "Manage your two-factor authentication settings and backup recovery codes",
    "ENABLED": "Activado",
    "DISABLED": "Deshabilitado",
    "STATUS_ENABLED": "Two-factor authentication is active",
    "STATUS_ENABLED_DESC": "Your account is protected with an additional layer of security",
    "ENABLE_BUTTON": "Enable Two-Factor Authentication",
    "ENHANCE_SECURITY": "Enhance Your Account Security",
    "ENHANCE_SECURITY_DESC": "Two-factor authentication adds an extra layer of security by requiring a verification code from your authenticator app in addition to your password.",
    "SETUP": {
      "STEP_NUMBER_1": "1",
      "STEP_NUMBER_2": "2",
      "STEP1_TITLE": "Scan QR Code with Your Authenticator App",
      "STEP1_DESCRIPTION": "Use Google Authenticator, Authy, or any TOTP-compatible app",
      "LOADING_QR": "Cargando...",
      "MANUAL_ENTRY": "Can't scan? Enter code manually",
      "SECRET_KEY": "Secret Key",
      "COPY": "Copiar",
      "ENTER_CODE": "Enter the 6-digit code from your authenticator app",
      "ENTER_CODE_PLACEHOLDER": "000000",
      "VERIFY_BUTTON": "Verify & Continue",
      "CANCEL": "Cancelar",
      "ERROR_STARTING": "MFA not enabled. Please contact administrator.",
      "INVALID_CODE": "Invalid verification code",
      "SECRET_COPIED": "Secret key copied to clipboard",
      "SUCCESS": "Two-factor authentication has been enabled successfully"
    },
    "BACKUP": {
      "TITLE": "Save Your Backup Codes",
      "DESCRIPTION": "Keep these codes safe. Each can be used once if you lose access to your authenticator",
      "IMPORTANT": "Important:",
      "IMPORTANT_NOTE": " Save these codes in a secure location. You won't be able to see them again.",
      "DOWNLOAD": "Descargar",
      "COPY_ALL": "Copy All",
      "CONFIRM": "I have saved my backup codes in a secure location and understand that I won't be able to see them again",
      "COMPLETE_SETUP": "Complete Setup",
      "CODES_COPIED": "Backup codes copied to clipboard"
    },
    "MANAGEMENT": {
      "BACKUP_CODES": "Backup Codes",
      "BACKUP_CODES_DESC": "Generate new codes if you've lost or used your existing ones",
      "REGENERATE": "Regenerate Backup Codes",
      "DISABLE_MFA": "Disable 2FA",
      "DISABLE_MFA_DESC": "Remove two-factor authentication from your account",
      "DISABLE_BUTTON": "Disable Two-Factor Authentication"
    },
    "DISABLE": {
      "TITLE": "Disable Two-Factor Authentication",
      "DESCRIPTION": "You'll need to enter your password and a verification code to disable two-factor authentication.",
      "PASSWORD": "Contraseña",
      "OTP_CODE": "Verification Code",
      "OTP_CODE_PLACEHOLDER": "000000",
      "BACKUP_CODE": "Backup Code",
      "BACKUP_CODE_PLACEHOLDER": "Enter one of your backup codes",
      "USE_BACKUP_CODE": "Lost access to your authenticator? Use a backup code instead",
      "USE_OTP_CODE": "Use a verification code from your authenticator app",
      "CONFIRM": "Disable 2FA",
      "CANCEL": "Cancelar",
      "SUCCESS": "Two-factor authentication has been disabled",
      "ERROR": "Failed to disable MFA. Please check your credentials."
    },
    "REGENERATE": {
      "TITLE": "Regenerate Backup Codes",
      "DESCRIPTION": "This will invalidate your existing backup codes and generate new ones. Enter your verification code to continue.",
      "OTP_CODE": "Verification Code",
      "OTP_CODE_PLACEHOLDER": "000000",
      "CONFIRM": "Generate New Codes",
      "CANCEL": "Cancelar",
      "NEW_CODES_TITLE": "New Backup Codes Generated",
      "NEW_CODES_DESC": "Your old backup codes have been invalidated. Save these new codes in a secure location.",
      "CODES_IMPORTANT": "Important:",
      "CODES_IMPORTANT_NOTE": " Each code can only be used once. Save them before closing this window.",
      "DOWNLOAD_CODES": "Download Codes",
      "COPY_ALL_CODES": "Copy All Codes",
      "CODES_SAVED": "I've Saved My Codes",
      "SUCCESS": "New backup codes have been generated",
      "ERROR": "Failed to regenerate backup codes"
    }
  },
  "MFA_VERIFICATION": {
    "TITLE": "Two-Factor Authentication",
    "DESCRIPTION": "Enter your verification code to continue",
    "AUTHENTICATOR_APP": "Authenticator App",
    "BACKUP_CODE": "Backup Code",
    "ENTER_OTP_CODE": "Enter 6-digit code from your authenticator app",
    "ENTER_BACKUP_CODE": "Enter one of your backup codes",
    "BACKUP_CODE_PLACEHOLDER": "000000",
    "VERIFY_BUTTON": "Verify",
    "TRY_ANOTHER_METHOD": "Try another verification method",
    "CANCEL_LOGIN": "Cancel and return to login",
    "HELP_TEXT": "Having trouble signing in?",
    "LEARN_MORE": "Learn more about 2FA",
    "HELP_MODAL": {
      "TITLE": "Two-Factor Authentication Help",
      "AUTHENTICATOR_TITLE": "Using an Authenticator App",
      "AUTHENTICATOR_DESC": "Open your authenticator app (Google Authenticator, Authy, etc.) and enter the 6-digit code shown for your account.",
      "BACKUP_TITLE": "Using a Backup Code",
      "BACKUP_DESC": "If you don't have access to your authenticator app, you can use one of the backup codes you saved when setting up 2FA. Each code can only be used once.",
      "CONTACT_TITLE": "Need More Help?",
      "CONTACT_DESC_CLOUD": "If you've lost access to both your authenticator app and backup codes, please reach out to Chatwoot support for assistance.",
      "CONTACT_DESC_SELF_HOSTED": "If you've lost access to both your authenticator app and backup codes, please contact your administrator for assistance."
    },
    "VERIFICATION_FAILED": "Verification failed. Please try again."
  }
}
